import React from 'react';
import './OrderSummary.css';

const OrderSummary = ({ items, subtotal, tipPercentage, tipAmount, totalAmount }) => {
  return (
    <div className="order-summary">
      <h3>Resumen pedido</h3>
      
      <div className="order-items">
        {items.map(item => (
          <div key={item.cartId} className="order-item">
            <div className="item-info">
              <span className="item-name">{item.quantity}x {item.name}</span>
              <span className="item-options">
                {item.size} • {item.sweetness} • {item.takeaway ? 'Takeaway' : 'For here'}
              </span>
            </div>
            <span className="item-price">${(item.finalPrice * item.quantity).toFixed(2)}</span>
          </div>
        ))}
      </div>
      
      <div className="order-totals">
        <div className="total-row">
          <span>Subtotal</span>
          <span>${subtotal.toFixed(2)}</span>
        </div>
        
        <div className="total-row">
          <span>Tip ({Math.round(tipPercentage * 100)}%)</span>
          <span>${tipAmount.toFixed(2)}</span>
        </div>
        
        <div className="total-row grand-total">
          <span>Total</span>
          <span className="grand-total-amount">${totalAmount.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;